window.homeJs = function () {
    // if (!$.cookie("animation")) {
    //     $('.site-wrapper').addClass('op-0') 
    //     $(".loading-animation").removeClass("close-animation");
       
    //     setTimeout(function () {
    //          $(".site-wrapper").removeClass("op-0");
    //          $(".loading-animation").addClass("close-animation");
    //         $.cookie("animation", true, { path: '/'});
    //     }, 4200);
    // } else {
    //     $(".loading-animation").addClass("close-animation");
    //     $(".site-wrapper").removeClass("op-0");
    // }

    $(".list-wrap-scroll li").click(function () {
        $(".list-wrap-scroll li").removeClass("active-proc");
        $(this).addClass("active-proc");
        let type = $(this).data("type");
        $("[data-type=" + type + "]").show();
    });

    if ($(".list-wrap-scroll")) {
        $(".list-wrap-scroll li").first().click();
    }

    // $(".list-wrapper ul").css({ maxHeight: $(".list-wrapper").height() });
    $(".list-wrapper").html($(".list-wrapper").html() + $(".list-wrapper").html());
    var timeout = null;
    function autoScrollUp() {
        timeout = setTimeout(() => {
            var el = document.querySelector(".select-kryptonite");
            if (el) {
                if (el.scrollTop >= el.scrollHeight - el.clientHeight - 3) {
                    var next = 0;
                } else {
                    var next = el.scrollTop + 1;
                }
                el.scrollTo(0, next);
                autoScrollUp();
            }
        }, 15);
    }
    autoScrollUp();

    $(".list-wrapper ul li").hover(function () {
        clearTimeout(timeout);
    });
    $(".list-wrapper ul li").mouseleave(function () {
        autoScrollUp();
    });

    var animatedText = document.querySelector(".good-skin-img");
    let observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.intersectionRatio > 0) {
                animatedText.style.display = "block";
            }
        },
        {
            root: null,
            rootMargin: "0px",
            threshold: 0.1
        }
    );
    observer.observe(animatedText);
};
